import { createStore } from "vuex";

// 创建一个新的 store 实例
export const store = createStore({
  state() {
    return {
      // 文章数据
      articlesData: [],
      // 用户信息数据
      userInfoData: [],
      // 是否是登陆状态
      isLoggedIn: false,
      chosenImage: "",
      createAllianceData: {
        teamName: "",
        yourName: "",
        teamUrl: "",
        teamIntroduce: "",
        chosenImage: "",
      },
    };
  },
  mutations: {
    setArticlesData(state, data) {
      state.articlesData = data;
    },
    setUserInfoData(state, data) {
      state.userInfoData = data;
    },
    setChosenImage(state, image) {
      state.chosenImage = image;
    },
    updateAllianceData(state, payload) {
      state.createAllianceData = { ...state.createAllianceData, ...payload };
    },
    setLoggedIn(state, loggedIn) {
      state.isLoggedIn = loggedIn;
    },
  },
  actions: {
    updateArticlesData({ commit }, data) {
      commit("setArticlesData", data);
    },
    updateUserInfoData({ commit }, data) {
      commit("setUserInfoData", data);
    },
    updateChosenImage({ commit }, image) {
      commit("setChosenImage", image);
    },
    // 登陆成功后更新一下这个状态
    updateLoggedIn({ commit }, data) {
      // this.isLoggedIn = loggedIn;
      commit("setLoggedIn", data);
    },
  },
  getters: {
    chosenImage: (state) => state.chosenImage,
    createAllianceData: (state) => state.createAllianceData,
  },
});
